// Terms pass B — legacy accounts with contacts, terms, wave, notice status and per-account recipient selection.
import { useState } from "react";
import { Card, call, errText, ghost, inp } from "./shared";

function ContactCells({ row, slug, edit, onSaved }) {
  const [f, setF] = useState(null);
  const [err, setErr] = useState(null);
  if (!f) return (
    <>
      <td className="px-2 py-1.5">{row.ap_contact_name || "—"}</td>
      <td className="px-2 py-1.5">{row.ap_email || <span className="text-[#b91c1c]">no email</span>}</td>
      <td className="px-2 py-1.5">{row.ap_phone || "—"}
        {edit && <button className="ml-2 text-xs text-[#0072bc]" onClick={() => setF({ ap_contact_name: row.ap_contact_name || "", ap_email: row.ap_email || "", ap_phone: row.ap_phone || "" })} data-testid={`legacy-edit-${row.id}`}>Edit</button>}</td>
    </>
  );
  const save = async () => {
    setErr(null);
    try { onSaved(await call("patch", `/accounts/${row.id}`, slug, f)); setF(null); } catch (e) { setErr(errText(e)); }
  };
  return (
    <td colSpan={3} className="px-2 py-1.5">
      <div className="flex gap-1 flex-wrap items-center">
        {["ap_contact_name", "ap_email", "ap_phone"].map((k) => <input key={k} className={`${inp} w-40`} placeholder={k.replace("ap_", "").replace("_", " ")} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`legacy-${k}-${row.id}`} />)}
        <button className={ghost} onClick={save} data-testid={`legacy-save-${row.id}`}>Save</button>
        <button className="text-xs" onClick={() => setF(null)}>Cancel</button>
        {err && <span className="text-xs text-[#b91c1c]" data-testid={`legacy-error-${row.id}`}>{err}</span>}
      </div>
    </td>
  );
}

export function LegacyAccounts({ slug, rows, edit, onRowSaved, onSelectionSaved }) {
  const [err, setErr] = useState(null);
  const selected = rows.filter((r) => r.notice_selected).map((r) => r.id);
  const save = async (ids) => {
    setErr(null);
    try { await call("put", "/selection", slug, { register_ids: ids }); onSelectionSaved(ids); } catch (e) { setErr(errText(e)); }
  };
  const toggle = (id) => save(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <Card title={`Legacy accounts (${rows.length})`} testId="legacy-accounts" right={
      <div className="flex items-center gap-2 text-sm">
        <span data-testid="legacy-selected-count"><b>{selected.length}</b> selected</span>
        {edit && <><button className={ghost} onClick={() => save(rows.map((r) => r.id))} data-testid="legacy-select-all">Select all</button>
          <button className={ghost} onClick={() => save([])} data-testid="legacy-select-none">Select none</button></>}
      </div>}>
      {err && <div className="text-xs text-[#b91c1c]" data-testid="legacy-selection-error">{err}</div>}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-[#6b7280]"><tr>{["Send", "Company", "Contact", "AP email", "Phone", "Terms", "Method", "Wave", "Notice"].map((h) => <th key={h} className="px-2 py-1.5 font-medium">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[#f1f2f4]" data-testid={`legacy-row-${r.id}`}>
                <td className="px-2 py-1.5"><input type="checkbox" checked={!!r.notice_selected} disabled={!edit} onChange={() => toggle(r.id)} data-testid={`legacy-select-${r.id}`} /></td>
                <td className="px-2 py-1.5 font-medium">{r.company_name}</td>
                <ContactCells row={r} slug={slug} edit={edit} onSaved={onRowSaved} />
                <td className="px-2 py-1.5">{r.terms_label}</td>
                <td className="px-2 py-1.5">{r.payment_method}</td>
                <td className="px-2 py-1.5">{r.legacy_wave}</td>
                <td className="px-2 py-1.5" data-testid={`legacy-notice-${r.id}`}>{r.notice_status || "—"}{r.notice_error ? ` (${r.notice_error})` : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
